import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  APPOINTMENT_FEATURE_KEY,
  State,
  AppointmentPartialState,
  appointmentAdapter
} from './appointment.reducer';
import * as AuthSelectors from '../auth/auth.selectors';
import { isAppointmentActive, isAppointmentCloseToStart, isProvider } from '@care-portals/shared';

// Lookup the 'Appointment' feature state managed by NgRx
export const getAppointmentState = createFeatureSelector<
  AppointmentPartialState,
  State
>(APPOINTMENT_FEATURE_KEY);

const { selectAll, selectEntities } = appointmentAdapter.getSelectors();

export const getInitialized = createSelector(
  getAppointmentState,
  (state: State) => state.isInitialized
);

export const getAppointmentLoading = createSelector(
  getAppointmentState,
  (state: State) => state.loading
);

export const getAppointmentCreating = createSelector(
  getAppointmentState,
  (state: State) => state.creating
);

export const getAppointmentUpdating = createSelector(
  getAppointmentState,
  (state: State) => state.updating
);

export const getAppointmentPulling = createSelector(
  getAppointmentState,
  (state: State) => state.pulling
);

export const getAppointmentError = createSelector(
  getAppointmentState,
  (state: State) => state.error
);

export const getAllAppointment = createSelector(
  getAppointmentState,
  (state: State) => selectAll(state)
);

export const getAppointmentEntities = createSelector(
  getAppointmentState,
  (state: State) => selectEntities(state)
);

export const getSelectedId = createSelector(
  getAppointmentState,
  (state: State) => state.selectedId
);

export const getSelected = createSelector(
  getAppointmentEntities,
  getSelectedId,
  (entities, selectedId) => (selectedId ? entities[selectedId] : null)
);

export const canStartSession = createSelector(
  getSelected,
  AuthSelectors.getRole,
  (appointment, role)=> isProvider(role) && isAppointmentCloseToStart(appointment.reservation) &&
  isAppointmentActive(appointment)
)
